export default __webpack_public_path__ + "3baed135f621f1a2e0f2e35bdf6d436c.png";